var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 64,
    viewBox: "0 0 444 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 32C442.5 33.4572 441.465 35.2229 438.626 37.2228C435.839 39.1861 431.632 41.1406 426.07 43.036C414.966 46.8203 398.817 50.2522 378.764 53.1428C338.68 58.9206 283.255 62.5 222 62.5C160.745 62.5 105.32 58.9206 65.2363 53.1428C45.1831 50.2522 29.0338 46.8203 17.9297 43.036C12.368 41.1406 8.16118 39.1861 5.37407 37.2228C2.53501 35.2229 1.5 33.4572 1.5 32C1.5 30.5428 2.53501 28.7771 5.37407 26.7772C8.16118 24.8139 12.368 22.8594 17.9297 20.964C29.0338 17.1797 45.1831 13.7478 65.2363 10.8572C105.32 5.07942 160.745 1.5 222 1.5C283.255 1.5 338.68 5.07942 378.764 10.8572C398.817 13.7478 414.966 17.1797 426.07 20.964C431.632 22.8594 435.839 24.8139 438.626 26.7772C441.465 28.7771 442.5 30.5428 442.5 32Z",
    stroke: "url(#paint0_radial)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-56.0003 70.5) rotate(14.0879) scale(120.628 556.649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D66506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2);
export default __webpack_public_path__ + "static/media/Ellipse2.b06e02229b5c578e80d2cd6f6ea840fc.svg";
export { ForwardRef as ReactComponent };